import React from 'react'
import Section from './Section'
import Age from './Age'
import { useState } from 'react'
import Gender from './Gender'
import Nationality from './Nationality'

const Home = () => {
    const headingOne = "I know Your Age";
    const headingTwo = "Male or Female ?";
    const headingThree = "Are you from ...."
    const explainationOne = "Yes! You read it right. Give it a try and let me guess your age. If I won, then we proceed further, else, we do next...Ready ?";
    const explainationTwo = "Take this test and know weather the people with your name are male or female.You will be fascinated with the results.";
    const explainationThree = "You may be born in this country, but...people having your names migt not. and there is a probability that you may belong to a different country. check it here."

    const [data, setData] = useState("")
    const update = (id) => {
        setData(id)
    }

    return (
        <div className="home">
            {
                data === "a" ? <Age /> :
                    <div className="section_container">
                        <Section heading={headingOne} explaination={explainationOne} />
                        <div id="age" className="section_button" onClick={() => update("a")}>Enter</div>
                    </div>

            }
            {
                data === "b" ? <Gender/> :
                    <div className="section_container">
                        <Section heading={headingTwo} explaination={explainationTwo} />
                        <div id="gender" className="section_button" onClick={() => update("b")}>Enter</div>
                    </div>
            }

            {
                data === "c" ? <Nationality/> :
                    <div className="section_container">
                        <Section heading={headingThree} explaination={explainationThree} />
                        <div id="nationality" className="section_button" onClick={() => update("c")}>Enter</div>
                    </div>

            }

        </div>
    )
}

export default Home;
